<template>
  <div
    @mouseenter="hovering = true"
    @mouseleave="hovering = false"
  >
    <div :id="'response-container-' + response.id">
      <StreamSurvey
        :response="response"
        :questions="questions"
        :activityId="activityId"
        :baseResponse="baseResponse"
        :highlight="highlight"
        activityType="diary"
        @open-chart-modal="$emit('open-chart-modal',$event)"
        @toggleNotepad="$emit('toggleNotepad',$event)"
      >
      </StreamSurvey>
      <InlineEngagement
        ref="engagement"
        type="ActivityDiaryResponse"
        :sentiment="false"
        :reply="legacy ? true : false"
        :favourite="false"
        :destroy="true"
        :notepad="false"
        :response="response"
        :activityId="activityId"
        :replyState="replyState"
        :hovering="(hovering && !hovering_replies) ? true : false"
        :baseResponse="baseResponse"
        :slim="true"
        @toggle_replies="toggle_replies()"
        @toggle_reply_input="toggle_reply_input(true)"
        @toggleNotepad="$emit('toggleNotepad',$event)"
      >
      </InlineEngagement>      
    </div>
    <Replies
      ref="replies"
      :activityId="activityId"
      :replies="response.replies"
      repliable_type="ActivityDiaryResponse"
      :repliable_id="response.id"
      :replyState="replyState"
      :baseResponse="baseResponse"
      baseMorph="ActivityDiaryResponse"
      :baseMorphId="response.id"
      @cancel-reply-input="replyState.showReplyInput = false"
      @hovering-replies="hovering_replies = $event"
      @toggleNotepad="$emit('toggleNotepad',$event)"
    >
    </Replies>
  </div>
</template>

<script>
import { mapState } from "vuex";
import StreamSurvey from "@/modules/together-helpers/activities/response/StreamSurvey";
import InlineEngagement from "@/view/components/stream-responses/InlineEngagement";
import Replies from "@/view/components/stream-responses/Replies";

export default {
  name: "streamResponseDiary",

  props: {
    baseResponse: { type: Number, required: true },
    response: { type: Object, required: true },
    questions: { type: Array, required: true },
    activityId: { type: Number, required: true },
    highlight: { type: String, required: false, default: null }
  },

  data() {
    return {
      hovering: false,
      hovering_replies: false,
      replyState: {
        showReplies: false,
        showReplyInput: false
      }
    }
  },

  components: {
    StreamSurvey,
    InlineEngagement,
    Replies
  },

  methods: {
    toggle_replies: function() {
      if (this.replyState.showReplies) {
        this.toggle_reply_input(false);
      } else {
        this.replyState.showReplies = true;
      }
    },
    toggle_reply_input: function(bool) {
      this.replyState.showReplies = bool;
      this.replyState.showReplyInput = bool;
    }
  },

  watch: {
    replyCount: {
      handler(val) {
        if (val == 0) {
          this.toggle_reply_input(false);
        }
      },
      immediate: false
    }
  },

  computed: {
    ...mapState({
      legacy: state => state.projectStream.legacy
    }),
    replyCount: function() {
      return this.response.replies;
    }
  }
}
</script>